module.exports = __webpack_public_path__ + "static/media/logo.f04f74c0.svg";